import { render, staticRenderFns } from "./ArticleLinkedin.vue?vue&type=template&id=6c5be204&"
import script from "./ArticleLinkedin.vue?vue&type=script&lang=ts&"
export * from "./ArticleLinkedin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports